import { ComponentProps, FC, ReactNode, useEffect, useState } from "react";
import { Flex, Switch } from "@payping/web-components";

type SwitchProps = ComponentProps<typeof Switch>;

interface SwitchRowProps extends SwitchProps {
  label?: ReactNode;
}

export const SwitchRow: FC<SwitchRowProps> = ({
  className,
  label,
  checked,
  onChange,
  disabled,
  ...props
}: SwitchRowProps) => {
  const [isChecked, setIsChecked] = useState<boolean>(false);

  useEffect(() => setIsChecked(Boolean(checked)), [checked]);

  return (
    <Flex
      align="center"
      className="tw-w-full"
      gap={"small"}
      onClick={(event: any) => {
        if (!disabled) {
          onChange?.(!isChecked, event);
          setIsChecked(!isChecked);
        }
      }}
    >
      {label}
      <Switch onChange={label ? undefined : onChange} checked={isChecked} disabled={disabled} {...props} />
    </Flex>
  );
};

SwitchRow.displayName = "SwitchRow";
